import { Capacitor } from '@capacitor/core';
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

import { useScope, useUser } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import CustomerTitleItems from '@sophocles/components/App/CustomerTitleItems';
import TitleBar from '@sophocles/components/App/TitleBar';

import UserGrid from './components/UserGrid';

function CustomerUserGridView({ match: { params }, ...props }) {
  const { t } = useTranslation();
  const isNativePlatform = Capacitor.isNativePlatform();
  const { customer } = useScope();
  const { user } = useUser();

  return (
    <AppNav flex notFullHeight page="customer_users" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar
          showBackButton
          title={t('general.users')}
          items={
            isNativePlatform ? null : (
              <CustomerTitleItems user={user} customer={customer} params={params} page="users" />
            )
          }
        />
        <UserGrid customer={customer} persistScope="customerUserGrid" />
      </Box>
    </AppNav>
  );
}

export default withTranslation()(CustomerUserGridView);
